'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z' });

var Gavel = function Gavel(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Gavel = (0, _pure2.default)(Gavel);
Gavel.muiName = 'SvgIcon';

exports.default = Gavel;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Gavel.js
// module id = 2459
// module chunks = 0